import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'

import { httpOk, GET, POST, PUT } from 'helpers/api'
import { formatDate, formatMoney } from "helpers/helpers"
import { useSelector } from "react-redux"

function Index() {
	const { t } = useTranslation()

	const reduxSettings = useSelector(state => state.settings)

	const [data, setData] = useState([])
	const [paymentTypes, setPaymentTypes] = useState([])
	const [accounts, setAccounts] = useState([])

	const [selectedItem, setSelectedItem] = useState({})
	const [showModal, setShowModal] = useState(false)
	const [conversionModal, setConversionModal] = useState(false)

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/accounts', selectedItem, { loader: true })
		} else {
			response = await POST('/accounts', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			toggleModal(false)
			searchWithFilter()
			getPaymentTypes()
		}
	}

	async function conversionCreate(e) {
		e.preventDefault()

		var response = await POST('/accounts/conversion', selectedItem, { loader: true });

		if (httpOk(response)) {
			toggleConversionModal(false)
			searchWithFilter()
		}
	}

	async function selectAccount(option) {
		setSelectedItem({ ...selectedItem, 'from_account_id': option?.id, 'from_account_is_usd': option.is_usd });
		setAccounts(data.filter(item => item.id !== option.id))
	}

	function handleChangePayment(e) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy[e.target.name] = e.target.value.replace(/[^0-9.]/g, '');

		const fromIsUsd = selectedItemCopy.from_account_is_usd;

		if (fromIsUsd) {
			// Dollar → Sum: foydalanuvchi dollar va kurs kiritadi, sum avtomatik hisoblanadi
			if (e.target.name === 'amount_usd' || e.target.name === 'currency') {
				selectedItemCopy['amount'] = (Number(selectedItemCopy['amount_usd']) * Number(selectedItemCopy['currency'])).toFixed(2);
			}
		} else {
			// Sum → Dollar: foydalanuvchi sum va kurs kiritadi, dollar avtomatik hisoblanadi
			if (e.target.name === 'amount' || e.target.name === 'currency') {
				selectedItemCopy['amount_usd'] = Number(selectedItemCopy['currency']) > 0
					? (Number(selectedItemCopy['amount']) / Number(selectedItemCopy['currency'])).toFixed(2)
					: 0;
			}
		}

		setSelectedItem(selectedItemCopy)
	}

	function toggleConversionModal(bool = false, item = {}) {
		item.currency = reduxSettings.currency;
		setConversionModal(bool)
		setSelectedItem(item)
	}

	function toggleModal(bool, item = {}) {
		if (bool) setSelectedItem(item)

		setShowModal(bool)
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types?payment_type_category_ids=1,2&is_account=true')
		if (httpOk(response)) setPaymentTypes(response.data)
	}

	async function searchWithFilter() {
		var filterUrl = "/accounts"

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		getPaymentTypes()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('accounts')} [{data.length}]
				</h4>
				<div className="d-flex gap-2">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleConversionModal(true)}>
						{t('conversion')}
					</button>

					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '60%' }}>{t('payment_types')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('balance')}</th>
									<th style={{ 'width': '8%' }} className="text-center">{t('date')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td>
											{item?.payment_types?.map((item2, index2) => (
												<span key={index2}>
													{item2.name}
													{(index2 + 1) !== item?.payment_types?.length && ', '}
												</span>
											))
											}
										</td>
										<td className="text-end">{formatMoney(item.balance)}</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('payment_types')}</label>
							<Select
								options={paymentTypes}
								value={selectedItem.payment_types}
								onChange={(option) => setSelectedItem({ ...selectedItem, payment_types: option })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
								isClearable
								isMulti
							/>
						</div>
						<div className="form-check">
							<input id="is_usd" className="form-check-input" type="checkbox"
								checked={selectedItem?.is_usd ?? false}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'is_usd': e.target.checked })}
							/>
							<label className="form-check-label" htmlFor="is_usd">
								{t('dollar')}
							</label>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			{/* MODAL PAYMENT */}
			<Modal show={conversionModal} animation={false}
				centered dialogClassName="update-modal-width"
				backdrop="static" onHide={() => toggleConversionModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('conversion')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={conversionCreate} autoComplete="off">
						<div className="form-group">
							<label>{t('from_account')}</label>
							<Select
								options={data}
								value={data.find(option => option.id === selectedItem.from_account_id)}
								onChange={(option) => selectAccount(option)}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('to_account')}</label>
							<Select
								options={accounts}
								value={accounts.find(option => option.id === selectedItem.to_account_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'to_account_id': option.id, 'to_account_is_usd': option.is_usd })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="row">
							{selectedItem.from_account_is_usd ? (
								/* Dollar → Sum yo'nalishi */
								<>
									<div className="col-md-4">
										<div className="form-group">
											<label>{t('amount_usd')} (chiqim)<span className="required-mark">*</span></label>
											<input type="text" className="form-control" name="amount_usd"
												value={selectedItem.amount_usd ? formatMoney(selectedItem.amount_usd) : ''}
												onChange={(e) => handleChangePayment(e)} />
										</div>
									</div>
									<div className="col-md-4">
										<div className="form-group">
											<label>{t('rate')}<span className="required-mark">*</span></label>
											<input type="text" className="form-control" name="currency"
												value={selectedItem.currency ? formatMoney(selectedItem.currency) : ''}
												onChange={(e) => handleChangePayment(e)} />
										</div>
									</div>
									<div className="col-md-4">
										<div className="form-group">
											<label>{t('amount')} (kirish, avtomatik)</label>
											<input type="text" className="form-control bg-light" name="amount"
												value={selectedItem.amount ? formatMoney(selectedItem.amount) : ''}
												readOnly />
										</div>
									</div>
								</>
							) : (
								/* Sum → Dollar yo'nalishi */
								<>
									<div className="col-md-4">
										<div className="form-group">
											<label>{t('amount')} (chiqim)<span className="required-mark">*</span></label>
											<input type="text" className="form-control" name="amount"
												value={selectedItem.amount ? formatMoney(selectedItem.amount) : ''}
												onChange={(e) => handleChangePayment(e)} />
										</div>
									</div>
									<div className="col-md-4">
										<div className="form-group">
											<label>{t('rate')}<span className="required-mark">*</span></label>
											<input type="text" className="form-control" name="currency"
												value={selectedItem.currency ? formatMoney(selectedItem.currency) : ''}
												onChange={(e) => handleChangePayment(e)} />
										</div>
									</div>
									<div className="col-md-4">
										<div className="form-group">
											<label>{t('amount_usd')} (kirish, avtomatik)</label>
											<input type="text" className="form-control bg-light" name="amount_usd"
												value={selectedItem.amount_usd ? formatMoney(selectedItem.amount_usd) : ''}
												readOnly />
										</div>
									</div>
								</>
							)}
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={selectedItem.note ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleConversionModal(false)} tabIndex="-1">
								{t('cancel')}
							</button>
							{selectedItem.id ?
								<button type="submit" className="btn btn-primary w-100"
									disabled={!selectedItem.amount}>
									{t('save')}
								</button>
								:
								<button type="submit" className="btn btn-primary w-100">
									{t('save')}
								</button>
							}
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT */}
		</>
	)
}

export default Index